export default function parseCouponError({ errors=[] }) {
	if (!errors || !(errors?.length > 0)) return;
	// `errors` can be an array of arrays, or an array of strings
	// validation errors return and array of objects
	// multicart errors return [[cart_id, message, status]]
	const firstError = errors.find(e => !!e);

	if (!firstError) return;

	if (typeof firstError === 'string') {
		return firstError;
	}

	if (Array.isArray(firstError)) {
		return firstError[1];
	}

	return Object.values(firstError)[0];
}
